// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderDetails-module__main--VQaRa {
    background-color: var(--color-general-white);
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-top: 160px;
    overflow: hidden;
    flex-direction: column;
}

.OrderDetails-module__content--k60Jl {
    --left-column-padding: 30px;
    --left-column-width: calc(var(--grid-width-6) + var(--left-column-padding));
    width: var(--grid-width-10);
    display: grid;
    gap: 30px;
    grid-template-columns: var(--left-column-width) auto;
    height: 100%;
}

.OrderDetails-module__tableHeader--Utqo1 {
    padding-right: var(--left-column-padding);
}

.OrderDetails-module__table--j2JDk {
    display: grid;
    grid-template-columns: repeat(4, auto);
    grid-auto-flow: row;
    gap: 20px;
    overflow: auto;
    padding-right: var(--left-column-padding);
}

.OrderDetails-module__imageContainer--mmsuL {
    --size: 80px;
    width: var(--size);
    height: var(--size);
    border-radius: var(--border-radius);
    overflow: hidden;
}

.OrderDetails-module__imageContainer--mmsuL img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.OrderDetails-module__summary--EpEMq {
    padding: 20px !important;
}
`, "",{"version":3,"sources":["webpack://./src/dom/Demo/OrderDetails/OrderDetails.module.css"],"names":[],"mappings":"AAAA;IACI,4CAA4C;IAC5C,eAAe;IACf,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,2EAA2E;IAC3E,2BAA2B;IAC3B,aAAa;IACb,SAAS;IACT,oDAAoD;IACpD,YAAY;AAChB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,mCAAmC;IACnC,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B","sourcesContent":[".main {\n    background-color: var(--color-general-white);\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    padding-top: 160px;\n    overflow: hidden;\n    flex-direction: column;\n}\n\n.content {\n    --left-column-padding: 30px;\n    --left-column-width: calc(var(--grid-width-6) + var(--left-column-padding));\n    width: var(--grid-width-10);\n    display: grid;\n    gap: 30px;\n    grid-template-columns: var(--left-column-width) auto;\n    height: 100%;\n}\n\n.tableHeader {\n    padding-right: var(--left-column-padding);\n}\n\n.table {\n    display: grid;\n    grid-template-columns: repeat(4, auto);\n    grid-auto-flow: row;\n    gap: 20px;\n    overflow: auto;\n    padding-right: var(--left-column-padding);\n}\n\n.imageContainer {\n    --size: 80px;\n    width: var(--size);\n    height: var(--size);\n    border-radius: var(--border-radius);\n    overflow: hidden;\n}\n\n.imageContainer img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.summary {\n    padding: 20px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `OrderDetails-module__main--VQaRa`,
	"content": `OrderDetails-module__content--k60Jl`,
	"tableHeader": `OrderDetails-module__tableHeader--Utqo1`,
	"table": `OrderDetails-module__table--j2JDk`,
	"imageContainer": `OrderDetails-module__imageContainer--mmsuL`,
	"summary": `OrderDetails-module__summary--EpEMq`
};
export default ___CSS_LOADER_EXPORT___;
